import React from 'react';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

interface AmeupLoadingProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  fullScreen?: boolean;
}

export const AmeupLoading: React.FC<AmeupLoadingProps> = ({
  className,
  size = 'md',
  message = 'Carregando...',
  fullScreen = false,
}) => {
  const iconSizes = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  const containerClass = fullScreen
    ? 'min-h-screen fixed inset-0 z-50 bg-background'
    : '';

  return (
    <div className={cn('flex flex-col items-center justify-center p-8', containerClass, className)}>
      <Loader2 
        className={cn('animate-spin text-primary opacity-80', iconSizes[size])}
        style={{ animationDuration: '2s' }}
      />
      {message && (
        <p className="mt-4 text-sm text-muted-foreground animate-pulse">{message}</p>
      )}
    </div>
  );
};

export default AmeupLoading;
